import React, { Fragment, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { FormattedMessage } from 'react-intl/dist';
import { connect } from 'react-redux';

//Components

import ExchangeAssigneesManagement from './manage-assignees/ExchangeAssigneesManagment';
import NavBarContainer from '../common/NavBarContainer';
import SideNav from '../../components/individualPortal/navigation/SideNavigation';
import TicketQuickActionBar from './ticketQuickActionBar';
import TicketSendMessageContainer from './sendMessage/TicketSendMessageContainer';
import TicketTypesManager from '../../containers/ticketMgmtPortal/TicketTypesManager';
import TagsManagement from './manage-tags/TagsManagement';
import CustomFieldManagement from './manage-custom-fields/CustomFieldManagement';

import PrivateRoute from '../../components/navigation/PrivateRoute';

//Configs

import { configs } from '../../constants/configs/configs';
import {
    ticketManagementNavLinks,
    ticketManagementTicketDetailNavLinks
} from '../individualPortal/navigation/configs/ticketManagementSideNavConfigs';

// Utils

import { getTicketData } from '../../utils/localStorage/sendMessageLocalStorage';
import { environmentSelector } from '../../selectors/commonSelectors';
import { ALL_USER_ROLES } from '../../constants/roles/userRoleTypes';


const TicketMgmtContainer = (props) => {
    const {
        environment: {
            stateCode,
            ticketEnabled,
            user: {
                activeModuleName,
                role
            } = {}
        },
        location: {
            pathname: currentRoute = ''
        } = {}
    } = props;

    const {
        routes: {
            TICKET_MGMT_TYPES,
            TICKET_SEND_MESSAGE,
            TICKET_MGMT_EXCHANGE_ASSIGNEES,
            TICKET_MGMT_MANAGE_TAGS,
            TICKET_MGMT_MANAGE_CUSTOM_FIELDS
        }
    } = configs;

    const checkForTicketDetailCookie = () => {
        const cookies = `; ${document.cookie}`;
        const parts = cookies.split('; showExtendedMenu=true');
        return parts.length > 1;
    };

    const TICKETDETAILPAGE = checkForTicketDetailCookie();

    const [sideNavData, setSideNavData] = useState({ ...getTicketData() });

    const headingRenderFunction = (  ) => {

        if (TICKETDETAILPAGE) {
            return ( 
                <div className='tablet:grid-col-12 ticket-mgmt-qab'>
                    <TicketQuickActionBar ticketData={sideNavData} handleChange={setSideNavData}/>
                </div>
            );
        } else {
            let messageId;

            const appendix = currentRoute.split('/').pop();

            switch(currentRoute) {
                case TICKET_MGMT_EXCHANGE_ASSIGNEES:
                case TICKET_MGMT_MANAGE_TAGS:
                case TICKET_MGMT_MANAGE_CUSTOM_FIELDS:
                    messageId = `ticket_management_header.${ appendix }`;
                    break;
                default:
                    messageId = 'ticket_management_header.default';
            }

            return (
                <div className='tablet:grid-col-9'>
                    <h1 id = 'skip' className = 'ticket-mgmt-heading'>
                        <FormattedMessage id = { messageId } />
                    </h1>
                </div>
            );
        }

    };

    const sideNavRenderFunction = () => {
        if (TICKETDETAILPAGE) {
            return (
                <aside className='desktop:grid-col-3' id='ticket-detail-side-nav'>
                    <SideNav
                        {...{ stateCode }}
                        navLinks={ticketManagementTicketDetailNavLinks}
                        visibilityParams={sideNavData}
                        outerClass={'ticket-nav'}
                    />
                </aside>);
        } else {
            return (
                <aside className='desktop:grid-col-3' id='side-nav'>
                    <SideNav
                        {...{ stateCode }}
                        navLinks={ticketManagementNavLinks}
                        visibilityParams={{ ticketEnabled, role, activeModuleName }}
                    />
                </aside>
            );
        }
    };

    const isForAdminOrOperations = [ALL_USER_ROLES.ADMIN, ALL_USER_ROLES.OPERATIONS].includes(activeModuleName.toUpperCase());
    const isTicketManagementTypeAllowed = [ALL_USER_ROLES.ADMIN, ALL_USER_ROLES.OPERATIONS, ALL_USER_ROLES.SECURITY, ALL_USER_ROLES.BA].includes(activeModuleName.toUpperCase());

    return (
        <main className='usa-layout-docs usa-section gi-main-section' id='ticketManagement'>
            <div className='grid-container gi-grid-container'>
                <div className='grid-row grid-gap gi-wrapper'>
                    <div className='grid-col-12'>
                        <div className='grid-row'>
                            <NavBarContainer navBarClass='ticket-mgmt-top-nav grid-col-12'/>
                        </div>
                        <div className='grid-row'>
                            {
                                headingRenderFunction()
                            }
                        </div>
                    </div>
                    <Fragment>
                        {
                            sideNavRenderFunction()
                        }
                        <div className='desktop:grid-col-9' id='main-content'>
                            <Switch>
                                <Route path={ TICKET_SEND_MESSAGE } exact component={ TicketSendMessageContainer } />
                                <Route path={ TICKET_MGMT_EXCHANGE_ASSIGNEES } exact component={ ExchangeAssigneesManagement } />
                                <PrivateRoute path={ TICKET_MGMT_MANAGE_TAGS } isAllowed={isForAdminOrOperations} exact component={ TagsManagement } />
                                <PrivateRoute path = { TICKET_MGMT_TYPES } isAllowed={isTicketManagementTypeAllowed} exact = { false } component= { TicketTypesManager } />
                                <PrivateRoute path = { TICKET_MGMT_MANAGE_CUSTOM_FIELDS } isAllowed={isForAdminOrOperations} exact = { false } component= { CustomFieldManagement } />
                            </Switch>
                        </div>
                    </Fragment>

                </div>
            </div>
        </main>
    );
};

const mapStateToProps = state => ({
    environment: environmentSelector(state)
});

export default connect(mapStateToProps)(TicketMgmtContainer);